export const CREATE_PAYMENT_PLAN_STORE_KEY = 'PAYMENT_PLAN/CREATE_PAYMENT_PLAN';
export const DELETE_PAYMENT_PLAN_STORE_KEY = 'PAYMENT_PLAN/DELETE_PAYMENT_PLAN';
export const FORCE_DELETE_PAYMENT_PLAN_STORE_KEY = 'PAYMENT_PLAN/FORCE_DELETE_PAYMENT_PLAN';
export const DELETE_PAYMENT_PLAN_INSTALMENT_STORE_KEY = 'PAYMENT_PLAN/DELETE_PAYMENT_PLAN_INSTALMENT';
export const RESCHEDULE_PAYMENT_PLAN_INSTALMENT_STORE_KEY = 'PAYMENT_PLAN/RESCHEDULE_PAYMENT_PLAN_INSTALMENT';
export const PAYMENT_PLAN_INSTALMENT_DESIGNER_STORE_KEY = 'PAYMENT_PLAN/INSTALMENT_DESIGNER';
export const UPDATE_PAYMENT_PLAN_TENANT_DEFERRAL_STORE_KEY = 'PAYMENT_PLAN/UPDATE_TENANT_DEFERRAL';

export const DELETE_PAYMENT_PLAN_INSTALMENT_API_SUCCESS = 'PAYMENT_PLAN/DELETE_PAYMENT_PLAN_INSTALMENT_API_SUCCESS';

export interface DeletePaymentPlanInstalmentSuccessPayload {
  paymentPlanId: string;
  instalmentId: string;
}

export interface DeletePaymentPlanInstalmentSuccessAction {
  type: typeof DELETE_PAYMENT_PLAN_INSTALMENT_API_SUCCESS;
  payload: DeletePaymentPlanInstalmentSuccessPayload;
}

export const deletePaymentPlanInstalmentApiSuccess = (
  payload: DeletePaymentPlanInstalmentSuccessPayload,
): DeletePaymentPlanInstalmentSuccessAction => ({
  type: DELETE_PAYMENT_PLAN_INSTALMENT_API_SUCCESS,
  payload,
});

export type PaymentPlanActionTypes = DeletePaymentPlanInstalmentSuccessAction;
